import { FloydWrapper } from './Floyd.styled';
import floyd from './floyd-magic.png';

export const FloydImage = () => {
  return <img src={floyd} alt="floyd" />;
};

export const Floyd = () => {
  return (
    <FloydWrapper>
      <FloydImage />
    </FloydWrapper>
  );
};
